import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { FullScreenLoader } from '../components/loader';
import ErrorBoundary from '../components/error.boundary';
import Login from './screens/login';
import PasswordReset from './screens/password-reset';
import PasswordResetConfirm from './screens/password-reset-confirm';
import Logout from './screens/logout';
import PasswordResetInvalid from './screens/password-reset-invalid';
import PasswordResetComplete from './screens/password-reset-complete';
import useReCaptcha from '../hooks/use-recaptcha';
import NoMatch404 from '../components/NoMatch404';

const App = () => {
    useReCaptcha();

    return (
        <ErrorBoundary>
            <React.Suspense fallback={ <FullScreenLoader /> }>
                <BrowserRouter>
                    <Routes>
                        <Route
                            path="/login"
                            element={ <Login /> }
                        />
                        <Route
                            path="/logout"
                            element={ <Logout /> }
                        />
                        <Route
                            path="/forgot-your-password/invalid"
                            element={ <PasswordResetInvalid /> }
                        />
                        <Route
                            path="/forgot-your-password/complete"
                            element={ <PasswordResetComplete /> }
                        />
                        <Route
                            path="/forgot-your-password/confirm/:uid/:token"
                            element={ <PasswordResetConfirm /> }
                        />
                        <Route
                            path="/forgot-your-password"
                            element={ <PasswordReset /> }
                        />
                        <Route path="*" element={ <NoMatch404 /> } />
                    </Routes>
                </BrowserRouter>
            </React.Suspense>
        </ErrorBoundary>
    );
};

export default App;
